import { RouteConfig } from 'react-router-config'

import AppContainer from '../../client/containers/appContainer'
import FeaturePageContainer from '../../client/containers/featurePageContainer'
import HomePageContainer from '../../client/containers/homePageContainer'
import LandingPageContainer from '../../client/containers/landingPageContainer'
import NotFoundPageContainer from '../../client/containers/notFoundPageContainer'
import SearchPageContainer from '../../client/containers/searchPageContainer'

const routeConfig: RouteConfig[] = [
  {
    path: '/',
    component: AppContainer,
    routes: [
      {
        path: '/',
        exact: true,
        component: HomePageContainer
      },
      {
        component: FeaturePageContainer,
        path: '/feature'
      },
      {
        component: SearchPageContainer,
        path: '/category/*'
      },
      {
        component: SearchPageContainer,
        path: '/tags/:tags'
      },
      {
        component: SearchPageContainer,
        path: '/attributes/:key/:value'
      },
      {
        component: SearchPageContainer,
        path: '/search'
      },
      {
        path: '/free/:page',
        component: LandingPageContainer
      },
      {
        path: '/*',
        component: NotFoundPageContainer
      }
    ]
  }
]

export default routeConfig
